var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_83_5856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9885 11.2058C21.9885 10.3045 21.9137 9.64674 21.7517 8.96466H11.2192V13.0328H17.4015C17.2769 14.0438 16.6039 15.5663 15.1081 16.5894L15.0871 16.7256L18.4173 19.2466L18.648 19.2691C20.7669 17.3568 21.9885 14.5432 21.9885 11.2058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2192 21.9244C14.248 21.9244 16.7907 20.95 18.648 19.2692L15.1081 16.5894C14.1608 17.235 12.8894 17.6857 11.2192 17.6857C8.25267 17.6857 5.73487 15.7734 4.83735 13.1303L4.70579 13.1412L1.24304 15.76L1.19775 15.883C3.04247 19.464 6.83167 21.9244 11.2192 21.9244Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83713 13.1303C4.60031 12.4482 4.46325 11.7174 4.46325 10.9622C4.46325 10.207 4.60031 9.47621 4.82467 8.79413L4.81839 8.64886L1.31225 5.98804L1.19753 6.04136C0.437236 7.52737 0.000976562 9.19609 0.000976562 10.9622C0.000976562 12.7284 0.437236 14.397 1.19753 15.883L4.83713 13.1303Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2192 4.23869C13.3256 4.23869 14.7466 5.12785 15.5568 5.87089L18.7227 2.85018C16.7783 1.08405 14.248 0 11.2192 0C6.83166 0 3.04247 2.46039 1.19775 6.04135L4.82489 8.79412C5.73487 6.15102 8.25267 4.23869 11.2192 4.23869Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_83_5856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleColor);
export default __webpack_public_path__ + "static/media/google-color.9c1355ea172114f4eb74a0d8fd12ba1d.svg";
export { ForwardRef as ReactComponent };